import { Box, Flex, Image, Spacer, Text } from "@chakra-ui/react";
import React from "react";
import { useHistory } from "react-router-dom";
import { Facebook } from "react-feather";

interface navbarProps {}
const Navbar: React.FC<navbarProps> = (props: navbarProps) => {
  const history = useHistory();
  return (
    <Flex h="14vh" bg="white" color="black">
      <Box w="10rem" align="left">
        <Image src="/img/hrbee.png" boxSize="100%" />
      </Box>
      <Spacer />
      <Flex w="45rem" align="center" fontSize="20px" fontFamily="geometria">
        <Text onClick={() => history.push("/")}>Home</Text>
        <Spacer />
        <Text onClick={() => history.push("/about")}>About</Text>
        <Spacer />
        <Text onClick={() => history.push("/services")}>Services</Text>
        <Spacer />
        <Text onClick={() => history.push("/documents")}>Documents</Text>
        <Spacer />
        <Text onClick={() => history.push("/contact")}>Contact</Text>
      </Flex>
      <Spacer />
      <Flex alignItems="center" w="13rem" align="center">
        <Flex h="4rem" w="10rem" alignItems="center" direction="column">
          {/* <Text fontSize="smaller">Contact</Text>
          <Text fontSize="smaller" m={0}>
            0212343456
          </Text> */}
        </Flex>
        {/* <Facebook /> */}
      </Flex>
    </Flex>
  );
};

export default Navbar;
